(function () {
  const STORAGE_KEY = 'frankos_favorites';

  const IMG_WISHLIST_DEFAULT =
    'https://cdn.shopify.com/s/files/1/1050/0368/0076/files/Favorieten_Wit_512_Y_Fix.png';

  const IMG_WISHLIST_ACTIVE =
    'https://cdn.shopify.com/s/files/1/1050/0368/0076/files/Favorieten_Rood_512_Y_Fix.png';

  function getFavorites() {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function updateHeaderWishlistIcon() {
    const hasFavorites = getFavorites().length > 0;

    document
      .querySelectorAll('#header-component .frankos-wishlist-img')
      .forEach((img) => {
        const defaultSrc = img.dataset.frankosWishlistDefaultSrc || IMG_WISHLIST_DEFAULT;
        const activeSrc = img.dataset.frankosWishlistActiveSrc || IMG_WISHLIST_ACTIVE;
        const targetSrc = hasFavorites ? activeSrc : defaultSrc;

        if (img.getAttribute('src') !== targetSrc) {
          img.setAttribute('src', targetSrc);
        }

        img.closest('.frankos-wishlist-btn')?.classList.toggle(
          'frankos-wishlist-btn--active',
          hasFavorites
        );
      });
  }

  function scheduleUpdate() {
    updateHeaderWishlistIcon();
    setTimeout(updateHeaderWishlistIcon, 50);
    setTimeout(updateHeaderWishlistIcon, 150);
    setTimeout(updateHeaderWishlistIcon, 300);
    setTimeout(updateHeaderWishlistIcon, 700);
  }

  document.addEventListener('DOMContentLoaded', scheduleUpdate);
  window.addEventListener('load', scheduleUpdate);

  window.addEventListener('frankos:favorites-updated', scheduleUpdate);

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      scheduleUpdate();
    }
  });

  document.addEventListener(
    'click',
    function () {
      scheduleUpdate();
    },
    true
  );

  document.addEventListener('shopify:section:load', scheduleUpdate);

  const startObserver = function () {
    const headerGroup = document.querySelector('#header-group');

    if (!headerGroup || window.frankosHeaderWishlistObserverActive) {
      return;
    }

    window.frankosHeaderWishlistObserverActive = true;

    const observer = new MutationObserver(function () {
      scheduleUpdate();
    });

    observer.observe(headerGroup, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'class']
    });

    scheduleUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();